import { useState } from "react";
import { Check, Copy } from "lucide-react";

export default function CopyButton({ text, label = "Copy", testid }) {
  const [copied, setCopied] = useState(false);
  if (!text) return null;
  const handle = async () => {
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(text);
      } else {
        const ta = document.createElement("textarea");
        ta.value = text;
        ta.style.position = "fixed";
        ta.style.opacity = "0";
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
      }
      setCopied(true);
      setTimeout(() => setCopied(false), 1600);
    } catch {
      setCopied(false);
    }
  };
  return (
    <button type="button" className={`copy-button${copied ? " is-copied" : ""}`} onClick={handle} data-testid={testid}>
      {copied ? <Check size={14} /> : <Copy size={14} />}
      <span>{copied ? "Copied!" : label}</span>
    </button>
  );
}

export function parseSummarySections(text) {
  // Split the summarize output into {summary, keyPoints, definitions, facts} using the labels the prompt enforces.
  const result = { summary: "", keyPoints: "", definitions: "", facts: "", full: text || "" };
  if (!text) return result;
  const map = [
    ["summary", /short summary/i],
    ["keyPoints", /key points/i],
    ["definitions", /important definitions/i],
    ["facts", /important facts/i],
  ];
  const lines = text.split(/\r?\n/);
  let current = null;
  const buckets = { summary: [], keyPoints: [], definitions: [], facts: [] };
  for (const raw of lines) {
    const line = raw.replace(/^[*#\-\s]+/, "");
    const matched = map.find(([, pattern]) => pattern.test(line));
    if (matched && line.length < 80) { current = matched[0]; continue; }
    if (current) buckets[current].push(raw);
  }
  for (const key of Object.keys(buckets)) result[key] = buckets[key].join("\n").trim();
  return result;
}
